/**
 * Formats a full name from first and last name parts.
 * Handles null/undefined values and returns a default placeholder if both are empty.
 * 
 * @param firstName - The first name (can be null/undefined)
 * @param lastName - The last name (can be null/undefined)
 * @param defaultValue - Value to return if name is empty (defaults to '-')
 * @returns Formatted full name or default value
 */
export const formatFullName = (
    firstName: string | null | undefined,
    lastName: string | null | undefined,
    defaultValue: string = '-'
): string => {
    const fullName = `${firstName || ''} ${lastName || ''}`.trim();
    return fullName || defaultValue;
};
